import { motion } from "framer-motion";
import { GALLERY } from "../../lib/content";
import { Eyebrow } from "../Reveal";

export const Gallery = () => (
  <section id="gallery" data-testid="gallery" className="bg-background py-24 md:py-32 border-t border-border">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
        <div>
          <Eyebrow>The stay</Eyebrow>
          <h2 className="font-display text-5xl md:text-7xl font-light tracking-tight leading-[0.95] mt-4">
            Picture your
            <br />
            <span className="text-primary italic">group here.</span>
          </h2>
        </div>
        <p className="label-eyebrow text-muted-foreground max-w-xs">
          A look at the kind of hotels & venues we block · real event photos coming soon
        </p>
      </div>

      <div className="columns-2 md:columns-3 lg:columns-4 gap-4 [column-fill:_balance]">
        {GALLERY.map((g, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: (i % 4) * 0.08 }}
            className={`group relative overflow-hidden mb-4 break-inside-avoid border border-border ${
              i % 3 === 0 ? "aspect-[3/4]" : "aspect-square"
            }`}
          >
            <img
              src={g.img}
              alt={g.caption}
              className="w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-[900ms] ease-out"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <figcaption className="absolute bottom-0 left-0 p-5 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
              <span className="font-display text-white text-2xl font-light">{g.caption}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
